import { useMsal } from '@azure/msal-react'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIcon, Group, Stack, Text, Title } from '@mantine/core'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSessionInfo } from '../../contexts/SessionContext'
import { fetchOrganizationTransactionDetails } from '../../data/organization.service'
import { COLORS } from '../../utils/constants'
import TransactionDetailsComponent from '../../components/dashboard/TransactionDetailsComponent'
import { TransactionSummary } from '../../models/Transactions/TransactionSummary'
import { formatNumber } from '../../utils/displayUtils'

const TransactionDetailsPage = () => {
  const { transactionId } = useParams<{ transactionId: string }>()
  const { session } = useSessionInfo()
  const { instance } = useMsal()
  const [transactionDetails, setTransactionDetails] =
    useState<TransactionSummary | null>(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchDetails = async () => {
      if (!session?.organizationId || !transactionId) return
      setLoading(true)
      try {
        const details = await fetchOrganizationTransactionDetails(
          session.organizationId,
          transactionId,
          instance,
        )
        setTransactionDetails(details)
      } finally {
        setLoading(false)
      }
    }
    fetchDetails()
  }, [session?.organizationId, transactionId, instance])

  return (
    <Stack>
      <Group
        align='center'
        h={{ base: 'auto', sm: 70 }}
        px={24}
        py={{ base: 16, sm: 0 }}
        style={{
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <ActionIcon
          variant='subtle'
          onClick={() => navigate(-1)}
          size='lg'
          color={COLORS.LightGreen}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </ActionIcon>
        {transactionDetails && (
          <Group gap='xl'>
            <Stack gap={0}>
              <Text c='dimmed' size='sm'>
                Order Placed
              </Text>
              <Title order={4}>
                {new Date(transactionDetails.orderDate).toLocaleDateString(
                  'en-US',
                  { year: 'numeric', month: 'long', day: 'numeric' },
                )}
              </Title>
            </Stack>
            <Stack gap={0}>
              <Text c='dimmed' size='sm'>
                Total
              </Text>
              <Title order={4}>
                ${formatNumber(transactionDetails.totalAmount)}
              </Title>
            </Stack>
          </Group>
        )}
      </Group>
      <TransactionDetailsComponent
        transactionDetails={transactionDetails}
        loading={loading}
      />
    </Stack>
  )
}

export default TransactionDetailsPage
